var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.67 12c0-2.39 1.94-4.33 4.33-4.33s4.33 1.94 4.33 4.33-1.94 4.33-4.33 4.33S7.67 14.39 7.67 12zm1.5 0c0 1.56 1.27 2.83 2.83 2.83s2.83-1.27 2.83-2.83S13.56 9.17 12 9.17 9.17 10.44 9.17 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15c-1.06-1.65-1.06-4.34 0-6 2.45-3.82 6-6.02 9.75-6.02s7.3 2.2 9.74 6.02c1.06 1.65 1.06 4.34 0 6-2.44 3.82-5.99 6.02-9.74 6.02-3.76 0-7.31-2.2-9.75-6.02zm1.27-5.19c-.75 1.17-.75 3.21 0 4.38 2.16 3.39 5.25 5.33 8.48 5.33 3.23 0 6.32-1.94 8.48-5.33.75-1.17.75-3.21 0-4.38-2.16-3.39-5.25-5.33-8.48-5.33-3.23 0-6.32 1.94-8.48 5.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineEye);
export default __webpack_public_path__ + "static/media/vuesax-outline-eye.508af6f9ade9dc79129a55da7b1521fe.svg";
export { ForwardRef as ReactComponent };